import { useState } from 'react';
import { useNovaStore } from '../../store/useNovaStore';
import { UnlockKeyModal } from './UnlockKeyModal';

export function KeyStatusBar() {
  const keyUnlocked = useNovaStore((s) => s.keyUnlocked);
  const [showUnlock, setShowUnlock] = useState(false);

  return (
    <>
      <div className="flex items-center justify-between px-4 py-2.5 bg-neutral-50 border-b border-cime-border text-sm">
        {keyUnlocked ? (
          <span className="flex items-center gap-1.5 text-emerald-700 font-medium">
            <span aria-hidden="true">✅</span>
            Clé déverrouillée
          </span>
        ) : (
          <span className="flex items-center gap-1.5 text-neutral-500">
            <span aria-hidden="true">🔒</span>
            Clé verrouillée
          </span>
        )}
        {!keyUnlocked && (
          <button
            type="button"
            onClick={() => setShowUnlock(true)}
            className="text-xs font-semibold text-cime-primary hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-cime-primary/50 rounded"
          >
            Déverrouiller
          </button>
        )}
      </div>

      {showUnlock && <UnlockKeyModal onClose={() => setShowUnlock(false)} />}
    </>
  );
}
